import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxChecked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconInboxChecked"><Path fillRule="evenodd" clipRule="evenodd" d="M18.89 4.23923L11.1376 15.5696L6.08586 10.411L7.51481 9.01164L10.8624 12.4301L17.2394 3.10986L18.89 4.23923ZM5 13.9999V18.9999H19V13.9999H21V20.9999H3V13.9999H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInboxChecked;
